



















































































































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import PengirimanTransferInternal from "@/components/pti/PengirimanTransferInternal.vue";
import PenerimaanTransferInternal from "@/components/pti/PenerimaanTransferInternal.vue";
import { PtiTransferResponseItem } from "@/types/pti";
import RiwayatTransfer from "@/components/pti/RiwayatTransfer.vue";
import DialogVerifikasiSampai from "@/components/pti/DialogVerifikasiSampai.vue";
import ptiService from "@/services/TransferInternal";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";

@Component({
  components: {
    PengirimanTransferInternal,
    PenerimaanTransferInternal,
    RiwayatTransfer,
    DialogVerifikasiSampai
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class TransferInternalPage extends Vue {
  isReadOnly!: () => boolean;

  @Prop({ default: null }) readonly register!: number | null;
  @Prop({ default: "" }) readonly rm!: string;
  @Prop({ default: false }) readonly reload!: boolean;
  @Prop({ default: 0 }) randomNumber: number | null;

  get pasienRm(): string {
    return this.rm ? String(this.rm) : "";
  }
  historyTransferInternal: PtiTransferResponseItem[] = [];

  isForm = false;
  selectedId: number | null = null;
  selectedItem: any = null;

  selectedRegister = this.register;
  renderRiwayat = true;
  showVerifikasiSampai = false;
  verifyingSampai = false;

  get userLoginId() {
    return userModule.user.id;
  }

  get unitLoginId() {
    return userModule.user.unit_id;
  }

  get isPengirim() {
    return (
      Number(this.selectedItem?.from_user_id) === Number(this.userLoginId)
    );
  }

  get isPenerima() {
    return (
      this.selectedItem?.to_user_id != null &&
      Number(this.selectedItem?.to_user_id) === Number(this.userLoginId)
    );
  }

  get diUnitTujuan() {
    return String(this.selectedItem?.to_unit_id) === String(this.unitLoginId);
  }

  get showPengiriman() {
    return true;
  }

  get canVerifikasiSampai() {
    if (!this.selectedId || !this.selectedItem || this.isReadOnly()) {
      return false;
    }
    if (this.selectedItem.arrived_at || this.selectedItem.received_at) {
      return false;
    }
    return this.selectedItem.can_verify_arrival !== false;
  }

  async verifSampai(password: string) {
    if (this.verifyingSampai || !this.selectedId) return;
    this.verifyingSampai = true;

    try {
      const resp = await ptiService.arrive(
        Number(this.selectedId),
        this.unitLoginId,
        password
      );
      const data = resp?.data;
      if (data) {
        this.selectedItem = data;
        this.$nextTick(() => {
          const pengirimanComp = this.$refs.pengirimanRef as any;
          if (pengirimanComp && pengirimanComp.setDetail) {
            pengirimanComp.setDetail(data);
          }
        });
      }
      this.showVerifikasiSampai = false;
      appModule.sendSuccessNotice("Kedatangan pasien berhasil diverifikasi");
      this.load();
      this.$root.$emit("reload-ranap-global");
    } catch (err) {
      appModule.addMsgTtd(
        err?.response?.data?.message || "Verifikasi kedatangan gagal"
      );
    } finally {
      this.verifyingSampai = false;
    }
  }

  get showPenerimaan() {
    if (!this.selectedId) return false;

    if (this.selectedItem?.received_at) return true;

    if (this.isPengirim) return false;

    return !!this.selectedItem?.arrived_at;
  }

  get penerimaanCatatanOnly() {
    return (
      !!this.selectedItem?.received_at &&
      this.isPenerima &&
      this.diUnitTujuan
    );
  }

  get penerimaanReadonly() {
    if (this.isReadOnly()) return true;

    if (this.selectedItem?.received_at) {
      return !this.penerimaanCatatanOnly;
    }

    return !this.selectedItem?.arrived_at || this.isPengirim;
  }

  get pengirimanReadonly() {
    if (this.isReadOnly()) return true;

    if (!this.selectedId) return false;

    return !this.isPengirim || !!this.selectedItem?.received_at;
  }

  @Emit("close")
  onClose() {}

  @Emit("cancel")
  onCancel() {}

  @Emit("transfer-sent")
  onTransferSent(data: any) {
    return data;
  }

  reloadPage() {
    window.location.reload();
  }

  closeForm() {
    this.isForm = false;
    this.selectedId = null;
    this.selectedItem = null;
  }

  onNewForm() {
    this.selectedId = null;
    this.isForm = true;
    this.selectedItem = null;
    this.selectedRegister = this.register;

    this.$nextTick(() => {
      const pengirimanComp = this.$refs.pengirimanRef as any;
      if (pengirimanComp && pengirimanComp.resetForm) {
        pengirimanComp.resetForm();
      }
    });
  }

  onEdit(dataTransfer: any) {
    this.selectedItem = dataTransfer;
    this.selectedId = dataTransfer.id;
    this.selectedRegister = dataTransfer.register_id;
    this.isForm = true;

    this.$nextTick(() => {
      const pengirimanComp = this.$refs.pengirimanRef as any;
      if (pengirimanComp && pengirimanComp.setDetail) {
        pengirimanComp.setDetail(dataTransfer);
      }
    });
  }

  onPengirimSubmit() {
    this.closeForm();
    (this.$refs.riwayatTransfer as any).load();
  }

  onPenerimaanSubmit() {
    this.closeForm();
    (this.$refs.riwayatTransfer as any).load();
  }

  mounted() {
    console.log("register page", this.selectedRegister);
  }

  load() {
    const riwayatTransferComponent = this.$refs.riwayatTransfer as any;
    if (riwayatTransferComponent && riwayatTransferComponent.load) {
      riwayatTransferComponent.load();
    }
  }
}
